module.exports = __webpack_public_path__ + "static/img/fxh.2b61281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/fxh.png
// module id = Rjiw
// module chunks = 0